import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_TAKE_PAYMENT_FEATURE_GROUP } from './group';

export const PAYMENTS_TAKE_PAYMENT_FEATURES = {
  CREATE: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0300',
    name: 'payments_take_payment:create',
    description: 'Take a card payment on a patron behalf and email the receipt',
    action: 'create',
    product: 'payments',
    parentGuid: PAYMENTS_TAKE_PAYMENT_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_TAKE_PAYMENT_FEATURE_GROUP } from './group';

export const PAYMENTS_TAKE_PAYMENT_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_TAKE_PAYMENT_FEATURE_GROUP],
  features: featureList(PAYMENTS_TAKE_PAYMENT_FEATURES),
};
